import { router } from "@inertiajs/react";
import { Tabs } from "@mantine/core";
import { useRole } from "../../hooks/useProps";
import { type PathMethodType, useYearContext } from "../../hooks/useYearContext";
import { Role } from "../../models/enums/role";
import { apprentice_documents_path, apprentice_path, observations_apprentice_path } from "../../routes";

type ApprenticeViewProps = {
  apprenticeId: number;
  activeTab: ApprenticeViewTabValues;
};

export enum ApprenticeViewTabValues {
  VIEW = "view",
  OBSERVATIONS = "observations",
  DOCUMENTS = "documents",
}

const pathMap: Record<string, PathMethodType> = {
  [ApprenticeViewTabValues.OBSERVATIONS]: observations_apprentice_path,
  [ApprenticeViewTabValues.VIEW]: apprentice_path,
  [ApprenticeViewTabValues.DOCUMENTS]: apprentice_documents_path,
};

export function ApprenticeViewTabs({ apprenticeId, activeTab }: ApprenticeViewProps) {
  const { pathWithYearContext } = useYearContext();
  const role = useRole();

  const onChange = (value: string | null) => {
    if (value) {
      const path = pathMap[value];
      router.get(pathWithYearContext(path, apprenticeId));
    }
  };

  return (
    <Tabs defaultValue={ApprenticeViewTabValues.VIEW} value={activeTab} onChange={onChange} mb="0.5rem">
      <Tabs.List>
        <Tabs.Tab value={ApprenticeViewTabValues.VIEW}>Details</Tabs.Tab>
        <Tabs.Tab value={ApprenticeViewTabValues.DOCUMENTS}>Dokumente</Tabs.Tab>
        {role && [Role.ADMIN, Role.COACH].includes(role) && <Tabs.Tab value={ApprenticeViewTabValues.OBSERVATIONS}>Beobachtungen</Tabs.Tab>}
      </Tabs.List>
    </Tabs>
  );
}
